
import { AVATAR } from '../../constants.ts'

export default {
	name: 'LoadingPlaceholder',

	props: {
		type: {
			type: String,
			required: true,
			validator(value) {
				return ['conversations', 'messages', 'participants', 'event-cards'].includes(value)
			},
		},

		count: {
			type: Number,
			default: 5,
		},
	},

	computed: {
		placeholderData() {
			const data = []
			for (let i = 0; i < this.count; i++) {
				// set up amount of lines in skeleton and generate random widths for last line
				data.push({
					amount: this.type === 'messages'
						? 4
						: this.type === 'conversations' ? 2 : 1,
					width: this.type === 'participants'
						? '60%'
						: this.type === 'event-cards' ? '100%' : (Math.floor(Math.random() * 40) + 30) + '%',
					avatarSize: (this.type === 'messages' ? AVATAR.SIZE.SMALL : AVATAR.SIZE.DEFAULT) + 'px',
				})
			}
			return data
		},
	},
}
